import { useMemo } from 'react';
import { fieldMappingSelector } from 'slices/field.slice';
import { selectObjectTypesMap } from 'slices/objectTypes.slice';
import { useAppSelector } from 'slices/store';
import {
  type DescriptionFieldSetting,
  FieldSettingType,
  type LocationFieldSetting,
  type SubjectTemplateFieldSetting,
} from '@timeedit/calendar-integration-api-contract';
import { Tag } from '@timeedit/ui-components';
import { Tooltip } from '@timeedit/ui-components/antd';
import { getFieldDisplayInfo } from './fieldSettingUtils';

export type FieldSettingTagProps = {
  fieldSetting:
    | DescriptionFieldSetting
    | LocationFieldSetting
    | SubjectTemplateFieldSetting;
};

const FieldSettingTag = ({ fieldSetting }: FieldSettingTagProps) => {
  const objectTypesMap = useAppSelector(selectObjectTypesMap);
  const fieldsMap = useAppSelector(fieldMappingSelector);

  const displayInfo = useMemo(() => {
    const field =
      'fieldId' in fieldSetting ? fieldsMap[fieldSetting.fieldId] : undefined;
    const objectType =
      fieldSetting.type === FieldSettingType.objectField
        ? objectTypesMap[fieldSetting.objectTypeId]
        : undefined;
    return getFieldDisplayInfo(fieldSetting, field, objectType);
  }, [fieldSetting, fieldsMap, objectTypesMap]);

  const tag = (
    <Tag color={displayInfo.color} style={{ whiteSpace: 'pre' }}>
      {displayInfo.label}
    </Tag>
  );

  if (displayInfo.tooltip) {
    return <Tooltip title={displayInfo.tooltip}>{tag}</Tooltip>;
  }

  return tag;
};

export default FieldSettingTag;
